import type { PayloadAction } from '@reduxjs/toolkit';

import { createAppSlice } from './createAppSlice';

type SearchMethod = 'Pure search' | 'History' | 'Suggestion' | 'Top result';

export interface ModalProps {
  userParamsWasSent: boolean;
  firstPageViewWasSent: boolean;
  submittedSearch: boolean;
  searchMethod: SearchMethod;
  lastPageViewPath: string;
}

const initialState: ModalProps = {
  userParamsWasSent: false,
  firstPageViewWasSent: false,
  submittedSearch: false,
  searchMethod: 'Pure search',
  lastPageViewPath: '',
};

export const dataLayerSlice = createAppSlice({
  name: 'dataLayer',
  initialState,
  reducers: () => ({
    setUserParamsWasSent: (state, action: PayloadAction<boolean>) => {
      state.userParamsWasSent = action.payload;
    },
    setFirstPageViewWasSent: (state, action: PayloadAction<boolean>) => {
      state.firstPageViewWasSent = action.payload;
    },
    setSubmittedSearchTrue: (state) => {
      state.submittedSearch = true;
    },
    setSubmittedSearchFalse: (state) => {
      state.submittedSearch = false;
    },
    setSearchMethod: (state, action: PayloadAction<SearchMethod>) => {
      state.searchMethod = action.payload;
    },
    setLastPageViewPath: (state, action: PayloadAction<string>) => {
      state.lastPageViewPath = action.payload;
    },
  }),

  selectors: {
    selectUserParamsWasSent: (dataLayer) => dataLayer.userParamsWasSent,
    selectFirstPageViewWasSent: (dataLayer) => dataLayer.firstPageViewWasSent,
    selectSubmittedSearch: (dataLayer) => dataLayer.submittedSearch,
    selectSearchMethod: (dataLayer) => dataLayer.searchMethod,
    selectLastPageViewPath: (dataLayer) => dataLayer.lastPageViewPath,
  },
});

export const {
  setUserParamsWasSent,
  setFirstPageViewWasSent,
  setSubmittedSearchFalse,
  setSubmittedSearchTrue,
  setSearchMethod,
  setLastPageViewPath,
} = dataLayerSlice.actions;

export const {
  selectUserParamsWasSent,
  selectFirstPageViewWasSent,
  selectSubmittedSearch,
  selectSearchMethod,
  selectLastPageViewPath,
} = dataLayerSlice.selectors;
